// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ILn8","amount":"Amount_amount__Sn5B1","tip":"Amount_tip__3RdkY","tipHeader":"Amount_tipHeader__2eSx-","tipsWrap":"Amount_tipsWrap__B8SAA"};